export const toQuoteNumberWithDashes = (quoteNumber?: string): string => {
  if (!quoteNumber) return '';

  const quoteNo = quoteNumber.split('-').reduce((a, b) => a.trim() + b.trim());
  return `${quoteNo.slice(0, 4)}-${quoteNo.slice(4, 8)}-${quoteNo.slice(8)}`;
};
